import { apiInstance, gql } from "@/services/httpAdapter";
import { errorLogger } from "@Common/helpers/logger";

export async function getCommissionCyclesTemporaryGuaranteed({ locationId, department }) {
	const query = gql`
		query getCommissionCyclesTemporaryGuaranteed($locationId: String!, $department: String) {
			getCommissionCyclesTemporaryGuaranteed(locationId: $locationId, department: $department) {
				_id
				endDate
				startDate
				status
				title
				payPeriods {
					startDate
					endDate
				}
				temporaryGuaranties {
					temporaryGuaranteedId {
						_id
						title
						lastModifiedOn
						effectiveDateTo
						effectiveDateFrom
						updatedAt
						itemsCount
						createdOn
						createdAt
						createdBy {
							_id
							fullName
						}
						lastModifiedBy {
							_id
							fullName
						}
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
		department,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getCommissionCyclesTemporaryGuaranteed;
	} catch (err) {
		errorLogger(err, {
			function: "getCommissionCyclesTemporaryGuaranteed",
			message: "Error getting commission cycles temporary guaranteed",
			variables,
		});
		return null;
	}
}

export async function getTemporaryGuaranteedById({ locationId, listId, department }) {
	const query = gql`
		query getTemporaryGuaranteedById($locationId: String!, $_id: String!, $department: String) {
			getTemporaryGuaranteedById(locationId: $locationId, _id: $_id, department: $department) {
				_id
				title
				itemsCount
				effectiveDateFrom
				effectiveDateTo
				createdOn
				lastModifiedOn
				createdAt
				updatedAt
				createdBy {
					fullName
					_id
				}
				lastModifiedBy {
					fullName
					_id
				}
				items {
					_id
					addedBy {
						_id
						fullName
					}
					amount
					effectiveDateFromItem
					effectiveDateToItem
					entryDate
					updatedAt
					nameAssociate {
						_id
						fullName
						position
					}
					payoutFrequency
				}
			}
		}
	`;

	const variables = {
		locationId,
		department,
		_id: listId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getTemporaryGuaranteedById;
	} catch (err) {
		errorLogger(err, {
			function: "getTemporaryGuaranteedById",
			message: "Error getting temporary guaranteed by id",
			variables,
		});
		return null;
	}
}

export async function getMyTemporaryGuaranteed({ locationId, commissionCycleId, userId, listId }) {
	const query = gql`
		query getMyTemporaryGuaranteed($locationId: String!, $commissionCycleId: String!, $userId: String!, $_id: String) {
			getMyTemporaryGuaranteed(locationId: $locationId, commissionCycleId: $commissionCycleId, userId: $userId, _id: $_id) {
				_id
				addedBy {
					_id
					fullName
				}
				amount
				effectiveDateFromItem
				effectiveDateToItem
				entryDate
				nameAssociate {
					_id
					fullName
				}
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		userId,
		_id: listId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getMyTemporaryGuaranteed;
	} catch (err) {
		errorLogger(err, { function: "getMyTemporaryGuaranteed", message: "Error getting my temporary guaranteed", variables });
		return null;
	}
}
